module.exports = __webpack_public_path__ + "img/电梯动画10.8500482b.png";